import _isArray from 'lodash/isArray';
import _isNil from 'lodash/isNil';
export function getImages(images) {
  if (_isNil(images)) {
    return null;
  }
  if (_isArray(images)) {
    return images;
  }
  return [images];
}